import { Button } from "@mui/material"
import { useTranslation } from "react-i18next"
interface GetAddressProps {
    onClick: () => void
    isDisabled?: boolean
}
const GetAddressField = (props: GetAddressProps) => {
    const { t } = useTranslation(`signup`)
    const { onClick, isDisabled } = props
    return (
        <Button variant="text" onClick={onClick} disabled={isDisabled}>{ t(`get_address`) }</Button>
    )
}

export { GetAddressField }
export type { GetAddressProps }